import { BLACK_COLOR } from '../../../utils/constants'

const BoxIcon = () => (
  <svg
    width="28"
    height="25"
    viewBox="0 0 28 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.76646 1.8499C5.35671 1.8499 4.97791 2.06792 4.77208 2.42222L1.79575 7.54548H12.9836L12.9759 1.8499H5.76646ZM14.9759 1.8499L14.9836 7.54548H25.9003L22.8316 2.41001C22.624 2.06261 22.2491 1.8499 21.8444 1.8499H14.9759ZM0.117202 7.05058C0.0267771 7.20623 -0.00869782 7.37869 0.00481841 7.54548H0V9.24548V22C0 23.6569 1.34314 25 3 25H24.6923C26.3492 25 27.6923 23.6569 27.6923 22V9.24548V7.54548H27.6912C27.707 7.37252 27.6702 7.19315 27.5742 7.03264L24.2909 1.53799C23.7764 0.677058 22.8473 0.149902 21.8444 0.149902H14.6153H12.9792H5.76646C4.75099 0.149902 3.81223 0.690213 3.30213 1.56826L0.117202 7.05058ZM1.7 9.24548H9.64219V11.0512C9.64219 12.0729 10.4705 12.9012 11.4922 12.9012H16.4752C17.4969 12.9012 18.3252 12.0729 18.3252 11.0512V9.24548H25.9923V22C25.9923 22.718 25.4103 23.3 24.6923 23.3H3C2.28203 23.3 1.7 22.718 1.7 22V9.24548ZM11.3422 9.24548H16.6252V11.0512C16.6252 11.134 16.5581 11.2012 16.4752 11.2012H11.4922C11.4093 11.2012 11.3422 11.134 11.3422 11.0512V9.24548Z"
      fill={BLACK_COLOR}
    />
  </svg>

)

export default BoxIcon
